export enum ProfileCode {
  Administrator = "ADMINISTRATOR",
  Creator = "CREATOR",
  User = "USER",
  Demo = "DEMO",
}
